const TEXTS: Record<string, string> = {
  pl: "Jeżeli pojawił się błąd, zrób zrzut ekranu i prześlij go na stickers.tattooo@wp.pl. Dziękujemy za pomoc!",
  en: "If you see an error, please take a screenshot and send it to stickers.tattooo@wp.pl. Thank you for your help!",
  de: "Wenn ein Fehler auftritt, machen Sie bitte einen Screenshot und senden Sie ihn an stickers.tattooo@wp.pl. Danke für Ihre Hilfe!",
  fr: "Si une erreur apparaît, faites une capture d'écran et envoyez-la à stickers.tattooo@wp.pl. Merci pour votre aide !",
  it: "Se compare un errore, fai uno screenshot e invialo a stickers.tattooo@wp.pl. Grazie per l'aiuto!",
};

export function errorHelpText(): string {
  const seg = typeof window !== "undefined" ? window.location.pathname.split("/")[1] : "pl";
  return TEXTS[seg] || TEXTS.pl;
}
